import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AlertTriangle, Clock, UserX, TrendingDown, ChevronRight,
} from 'lucide-react';
import { Card } from '../../ui-v2';

const ICONOS = {
  vencimiento_critico: AlertTriangle,
  vencimiento_proximo: Clock,
  tecnico_sobrecargado: TrendingDown,
  no_asistio_alto: UserX,
};

export default function BloqueAlertas({ alertas }) {
  const navigate = useNavigate();

  if (!alertas || alertas.length === 0) return null;

  return (
    <div className="mb-6">
      <h2 className="text-base font-medium text-slate-900 mb-3 flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 text-amber-500" />
        Atención requerida
        <span className="text-xs font-normal text-slate-500 tabular-nums">
          ({alertas.length})
        </span>
      </h2>

      <div className="space-y-2">
        {alertas.map((a, idx) => {
          const Icon = ICONOS[a.tipo] || AlertTriangle;
          const esAlta = a.severidad === 'alta';
          const clickable = !!a.campana_id;
          const onClick = clickable
            ? () => navigate(`/citas-tecnicas/campanas/${a.campana_id}/resumen`)
            : undefined;

          return (
            <Card
              key={idx}
              onClick={onClick}
              className={
                'p-4 border-l-4 transition-colors ' +
                (esAlta
                  ? 'border-l-red-500 bg-red-50/30 hover:bg-red-50/60'
                  : 'border-l-amber-400 bg-amber-50/30 hover:bg-amber-50/60') +
                (clickable ? ' cursor-pointer' : '')
              }
            >
              <div className="flex items-start gap-3">
                <div className={
                  'w-8 h-8 rounded-full grid place-items-center shrink-0 ' +
                  (esAlta ? 'bg-red-100' : 'bg-amber-100')
                }>
                  <Icon className={
                    'w-4 h-4 ' + (esAlta ? 'text-red-600' : 'text-amber-700')
                  } />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-slate-900">
                    {a.titulo}
                  </div>
                  {a.descripcion && (
                    <p className="text-xs text-slate-600 mt-1 leading-relaxed">
                      {a.descripcion}
                    </p>
                  )}
                </div>

                {clickable && (
                  <ChevronRight className="w-4 h-4 text-slate-400 shrink-0 mt-1" />
                )}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
